import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import IndiProgram from "../IndiProgram";
import Embeddings from "../Embeddings";


function PanelIndiProgram() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Programs", "path": "/programs" },
        { "name": "Embeddings", "path": "/embeddings" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}indi-programs-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="indi-programs-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Indi Programs</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Programs" && <IndiProgram />
                }
                {
                    activeTab?.name == "Embeddings" && <Embeddings />
                }

            </div>
        </div>
    );
}

export default PanelIndiProgram;